import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/site/Reveal";

export const StorySection = () => {
  return (
    <section className="py-24 lg:py-32" data-testid="story-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal>
            <SectionLabel>The Story</SectionLabel>
            <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              THIS IS WHERE IT STARTS.
            </h2>
            <p className="mt-6 text-brand-textSec leading-relaxed">
              The Fish House Project starts with tanks scattered around a house. The plan is to build a
              dedicated rack in the office, start structured breeding projects, experiment with buying and
              selling fish, generate the first revenue, reinvest that money into the project and eventually
              see whether the business can grow enough to move into a dedicated unit.
            </p>
            <Link to="/journey" className="btn-primary mt-8 px-6 py-3 text-sm inline-flex items-center gap-2" data-testid="follow-journey-btn">
              Follow The Journey <ArrowRight size={16} />
            </Link>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="card-surface p-8 sm:p-12">
              <div className="space-y-6">
                {["A few tanks.", "One idea.", "A lot of work.", "And no guarantee it will work."].map((line, i) => (
                  <p
                    key={line}
                    className={`font-display font-extrabold leading-none tracking-tight ${
                      i === 3 ? "text-brand-cyan text-2xl sm:text-3xl" : "text-white text-3xl sm:text-4xl"
                    }`}
                  >
                    {line}
                  </p>
                ))}
              </div>
              <div className="mt-10 pt-6 border-t border-white/5">
                <p className="text-brand-textSec text-sm italic leading-relaxed">
                  "I don't know if this is going to work. But I'm going to build it, and I'm going to build it with you."
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
